import highchartsMore from 'highcharts/highcharts-more';
import map from 'highcharts/modules/map';
import accessibility from 'highcharts/modules/accessibility';
import annotations from 'highcharts/modules/annotations';
import brokenAxis from 'highcharts/modules/broken-axis';
import treemap from 'highcharts/modules/treemap';
import patternFill from 'highcharts/modules/pattern-fill';
import drilldown from 'highcharts/modules/drilldown';
import dumbbell from 'highcharts/modules/dumbbell';
import sankey from 'highcharts/modules/sankey';
import sunburst from 'highcharts/modules/sunburst';
import lollipop from 'highcharts/modules/lollipop';
import dependencyWheel from 'highcharts/modules/dependency-wheel';
import exporting from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import exportData from 'highcharts/modules/export-data';
import variwide from 'highcharts/modules/variwide';
import organization from 'highcharts/modules/organization';
function configure(Highcharts) {
    highchartsMore(Highcharts);
    map(Highcharts);
    accessibility(Highcharts);
    annotations(Highcharts);
    brokenAxis(Highcharts);
    treemap(Highcharts);
    patternFill(Highcharts);
    drilldown(Highcharts);
    dumbbell(Highcharts);
    sankey(Highcharts);
    sunburst(Highcharts);
    lollipop(Highcharts);
    dependencyWheel(Highcharts);
    exporting(Highcharts);
    offlineExporting(Highcharts);
    exportData(Highcharts);
    variwide(Highcharts);
    organization(Highcharts);
}
export default configure;
